<template>
    <div class="counter">
        <div class="counter-background" />
        <div class="add-background" :class="{ 'animating-add' : isAnimatingAdd }" />
        <div class="subtract-background" :class="{ 'animating-subtract' : isAnimatingSubtract }" />
        <div class="subtract-wrapper">
            <div class="subtract" @click="decreaseValue">
                <img alt="subtract" src="@/assets/subtract.svg" />
            </div>
        </div>
        <div
            class="number-wrapper"
            :class="{
                'animating-add' : isAnimatingAdd,
                'animating-subtract' : isAnimatingSubtract
            }"
            :style="{backgroundImage: `url(${tokenImagePath})` }"
        >
            <div class="number">{{ counterValue }}</div>
        </div>
        <div class="add-wrapper">
            <div class="add" @click="increaseValue">
                <img alt="add" src="@/assets/add.svg" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Counter',
        props: {
            tokenType: {
                type: String,
                required: true,
            },
            initialValue: {
                type: Number,
                default: 0,
            }
        },
        data() {
            return {
                counterValue: 0,
                isAnimatingAdd: false,
                isAnimatingSubtract: false,
            }
        },
        mounted() {
                if(localStorage[this.tokenType]) {
                    this.counterValue = localStorage[this.tokenType]
                } else {
                    this.counterValue = this.initialValue;
                }
        },
        watch: {
            counterValue(newCount) {
            localStorage[this.tokenType] = newCount;
            }
        },
        computed: {
            tokenImagePath () {
                switch(this.tokenType) {
                    case 'gold':
                        return this.getImgUrl('gold-icon');
                    case 'strength':
                        return this.getImgUrl('strength-icon');
                    case 'magic':
                        return this.getImgUrl('magic-icon');
                    case 'victory-points':
                        return this.getImgUrl('victory-points-icon');
                    default:
                        return ''
                }
            }
        },
        methods: {
            getImgUrl(name) {
                var images = require.context('../assets/', false, /\.svg$/)
                return images('./' + name + ".svg")
            },
            increaseValue() {
                this.counterValue++;
                this.animate('add');
            },
            decreaseValue() {
                if(this.counterValue > 0) {
                    this.counterValue--
                    this.animate('subtract');
                }
            },
            animate(type) {
                switch(type) {
                    case 'add':
                        this.isAnimatingAdd = true;
                        break;
                    case 'subtract':
                        this.isAnimatingSubtract = true;
                        break;
                }
                setTimeout(() => {
                    this.isAnimatingAdd = false;
                    this.isAnimatingSubtract = false;
                }, 100)
            }
        }
    }
</script>

<style scoped>
    .counter {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 30px 0;
        position: relative;
    }

    @media(max-height: 740px) {
        .counter {
            padding: 20px 0;
        }
    }

    @media(max-height: 660px) {
        .counter {
            padding: 10px 0;
        }
    }

    .counter-background, .subtract-background, .add-background {
        width: 100%;
        height: 50%;
        position: absolute;
        border-radius: 500px;
        z-index: -1;
        transition: opacity 0.1s;
        -webkit-transition: opacity 100ms;
    }

    .counter-background {
        background-color: white;
        opacity: 0.4;
    }

    .subtract-background {
        opacity: 0;
        background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
    }

    .add-background {
        opacity: 0;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
    }

    .subtract-background.animating-subtract, .add-background.animating-add {
        opacity: 0.6;
    }

    .subtract-wrapper,.add-wrapper,.number-wrapper {
        flex: 1;
        display: flex;
    }

    .add-wrapper {
        justify-content: flex-end;
    }

    .subtract, .add {
        height: 80px;
        width: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        padding: 0 20px;
        user-select: none;
    }

    @media(max-width: 320px){
        .subtract, .add {
            padding: 0 5px;
        }
    }

    .number-wrapper {
        width: 100px;
        height: 100px;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.1s ease-in-out;
        -webkit-transition: transform 100ms ease-in-out;
        -webkit-transition: -webkit-transform 100ms ease-in-out;
    }

    .number-wrapper.animating-add {
        transform: scale(1.3);
    }

    .number-wrapper.animating-subtract {
        transform: scale(0.7);
    }

    .number {
        font-family: Simonetta;
        font-weight: 900;
        font-size: 52px;
        line-height: 65px;
        text-align: center;
        letter-spacing: 0;
        color: #FFFFFF;
        -webkit-text-stroke: 3px #1E1E1E;
    }
</style>